// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"596e9b0a","455":"ed7fce5f"}[chunkId] + ".chunk.js";
};